import { schema } from 'normalizr';

export const BUS_AUTOCOMPLETE_STATION_ITEM_KEY = 'busAutoCompleteStationItem';

const busAutoCompleteStationItemSchema = new schema.Entity(
  BUS_AUTOCOMPLETE_STATION_ITEM_KEY,
  undefined,
  {
    idAttribute: 'code',
  }
);

export default busAutoCompleteStationItemSchema;
